/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_S2Inputs */

const en_mk_tut_ws_s2 = /** @type {(inputs: Mk_Tut_Ws_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick the divisions you want to try first. Start with one or two; adding more later is painless.`)
};

const id_mk_tut_ws_s2 = /** @type {(inputs: Mk_Tut_Ws_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centang divisi yang ingin Anda coba dulu. Mulai dari satu atau dua saja; menambah divisi nanti tidak merepotkan.`)
};

/**
* | output |
* | --- |
* | "Tick the divisions you want to try first. Start with one or two; adding more later is painless." |
*
* @param {Mk_Tut_Ws_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_s2 = /** @type {((inputs?: Mk_Tut_Ws_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_s2(inputs)
	return en_mk_tut_ws_s2(inputs)
});